import React from 'react';

const AboutUs = ({ title, content, imageUrl }) => {
  return (
    <section id="about" className="section-spacing bg-gradient-to-br from-white via-neutral-50/30 to-white relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-neutral-100/50 to-transparent transform -skew-y-1"></div>
      
      <div className="absolute top-32 right-20 w-32 h-32 bg-gradient-to-br from-accent-500/10 to-brand-600/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-20 left-10 w-24 h-24 bg-gradient-to-tr from-brand-500/10 to-accent-500/10 rounded-full blur-xl"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-brand-900 sm:text-5xl">
            {title || 'About Baniuaga Group'}
          </h2>
          <div className="w-24 h-1 bg-accent-500 mx-auto mt-4 mb-8"></div>
          <p className="max-w-3xl mx-auto text-xl text-neutral-600">
            Contributing to the sustainable development of Timor-Leste through focused business excellence
          </p>
        </div>
        
        <div className="md:flex md:items-start md:gap-20">
          <div className="md:w-2/5 mb-16 md:mb-0 relative">
            <div className="relative">
              <img
                src={imageUrl}
                alt="About Baniuaga Group"
                className="rounded-2xl shadow-xl w-full h-auto object-cover"
                style={{ maxHeight: "500px" }}
              />
              <div className="absolute -top-6 -right-6 w-full h-full bg-gradient-to-br from-accent-500/20 to-brand-600/20 rounded-2xl -z-10"></div>
            </div>
          </div>
          
          <div className="md:w-3/5">
            <div className="space-y-12">
              {content || (
                <>
                  <div className="relative">
                    <div className="absolute -left-8 top-0 w-1 h-20 bg-gradient-to-b from-accent-500 to-brand-600 rounded-full"></div>
                    <h3 className="text-3xl font-bold text-brand-900 mb-4">Our Purpose</h3>
                    <p className="text-lg text-neutral-700 leading-relaxed">
                      Baniuaga Group is a national holding company dedicated to business asset management and controlling subsidiary operations. We strive to create a valuable and meaningful company that delivers the best added value and service to the nation.
                    </p>
                  </div>
                  
                  <div className="relative pl-8">
                    <div className="absolute -left-4 top-0 w-3 h-3 bg-accent-500 rounded-full"></div>
                    <h3 className="text-2xl font-bold text-brand-900 mb-4">Our Vision</h3>
                    <p className="text-lg text-neutral-700 leading-relaxed">
                      Our vision is to contribute to the sustainable development of Timor-Leste's economy by building market-leading businesses through our focused approach and continuous enhancement of services for the benefit of our nation.
                    </p>
                  </div>
                  
                  <div className="relative pl-8">
                    <div className="absolute -left-4 top-0 w-3 h-3 bg-brand-600 rounded-full"></div>
                    <h3 className="text-2xl font-bold text-brand-900 mb-4">Our Mission</h3>
                    <p className="text-lg text-neutral-700 leading-relaxed">
                      We aim to emerge as the premier operational holding company focusing on Timor-Leste's development. Drawing on our strong team experience, we are committed to contributing to sustainable economic development and building a stronger future for our country.
                    </p>
                  </div>

                  <div className="relative pl-8">
                    <div className="absolute -left-4 top-0 w-3 h-3 bg-brand-600 rounded-full"></div>
                    <h3 className="text-2xl font-bold text-brand-900 mb-4">Our Values</h3>
                    <p className="text-lg text-neutral-700 leading-relaxed">
                      We foster integrity and confidentiality by adhering to the highest ethical standards. Professional integrity in all our operations constitutes one of our core strengths, enabling us to serve our nation with excellence and build lasting trust in everything we do.
                    </p>
                  </div>
                  
                  <div className="mt-12 flex justify-start">
                    <a href="#subsidiaries" className="group inline-flex items-center bg-gradient-to-r from-brand-600 to-accent-500 text-white hover:from-brand-700 hover:to-accent-600 font-semibold px-8 py-4 rounded-full transition-all duration-300 ease-in-out transform hover:scale-105 shadow-lg hover:shadow-xl">
                      Explore Our Subsidiaries
                      <svg className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                      </svg>
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;